import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["templateSelect", "templateIdInput", "subjectInput", "contentInput"]
  static values = { previewUrl: String }

  async refreshFromTemplate() {
    if (!this.hasTemplateSelectTarget || !this.previewUrlValue) return

    const templateId = this.templateSelectTarget.value
    const url = new URL(this.previewUrlValue, window.location.origin)
    if (templateId) url.searchParams.set("template_id", templateId)

    this.templateSelectTarget.disabled = true

    try {
      const response = await fetch(url.toString(), {
        headers: { Accept: "application/json" }
      })

      if (!response.ok) {
        throw new Error("Unable to load template preview.")
      }

      const draft = await response.json()
      if (this.hasTemplateIdInputTarget) this.templateIdInputTarget.value = draft.template_id || ""
      if (this.hasSubjectInputTarget) this.subjectInputTarget.value = draft.subject || ""
      if (this.hasContentInputTarget) this.contentInputTarget.value = draft.content || ""
    } catch (error) {
      if (window.showToast) {
        window.showToast("Template preview failed", error.message || "Unable to load template preview.")
      }
    } finally {
      this.templateSelectTarget.disabled = false
    }
  }
}
